/* Product grid image slider + color-swatch sync (added for design duplicate) */
(function () {
  var SEL = {
    root: '[data-pg-slider]',
    track: '[data-pg-slider-track]',
    slide: '[data-pg-slide]',
    dots: '[data-pg-slider-dots]',
    dot: '.pg__slider__dot',
    prev: '[data-pg-slider-prev]',
    next: '[data-pg-slider-next]',
    card: '.pg',
    swatchWrap: '.pg__options--below-price',
    swatch: '.pg__option__value.swatch__item--color'
  };

  function norm(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function stripTooltips(context) {
    var scope = (context && context.querySelectorAll) ? context : document;
    var wraps = scope.querySelectorAll(SEL.swatchWrap);
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.getAttribute('data-pg-tooltips-stripped')) return;
      wrap.setAttribute('data-pg-tooltips-stripped', '1');
      var els = wrap.querySelectorAll('[data-toggle="tooltip"]');
      Array.prototype.forEach.call(els, function (el) {
        el.removeAttribute('data-toggle');
        el.removeAttribute('data-original-title');
        el.removeAttribute('title');
        try {
          if (window.jQuery) {
            var $el = window.jQuery(el);
            if ($el.data('bs.tooltip') || $el.data('tooltip')) {
              $el.tooltip('destroy');
            }
          }
        } catch (e) { /* no-op */ }
      });
    });
  }

  function initSlider(root) {
    if (!root || root.getAttribute('data-pg-ready')) return;
    root.setAttribute('data-pg-ready', '1');
    var track = root.querySelector(SEL.track);
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll(SEL.slide)) : [];
    if (!track || slides.length < 2) return;

    var dotsWrap = root.querySelector(SEL.dots);
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll(SEL.dot)) : [];

    function setActive(slide) {
      if (!slide) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      var idx = slides.indexOf(slide);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(entry.target);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function goTo(slide) {
      if (!slide) return;
      try {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      } catch (e) {
        track.scrollLeft = slide.offsetLeft;
      }
      setActive(slide);
    }

    var prevBtn = root.querySelector(SEL.prev);
    var nextBtn = root.querySelector(SEL.next);

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = currentIndex();
        goTo(slides[Math.min(idx + 1, slides.length - 1)]);
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = currentIndex();
        goTo(slides[Math.max(idx - 1, 0)]);
      });
    }

    root.pgGoToColor = function (colorValue) {
      var target = null;
      for (var i = 0; i < slides.length; i++) {
        if (norm(slides[i].getAttribute('data-color-value')) === norm(colorValue)) {
          target = slides[i];
          break;
        }
      }
      if (target) goTo(target);
    };
  }

  function initAll(context) {
    var scope = (context && context.querySelectorAll) ? context : document;
    var roots = scope.querySelectorAll(SEL.root);
    Array.prototype.forEach.call(roots, initSlider);
    stripTooltips(scope);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest ? e.target.closest(SEL.swatch) : null;
    if (!swatch) return;
    var wrap = swatch.closest(SEL.swatchWrap);
    if (!wrap) return;
    e.preventDefault();
    var card = swatch.closest(SEL.card);
    if (!card) return;
    var slider = card.querySelector(SEL.root);
    if (!slider) return;
    initSlider(slider);
    var colorValue = swatch.getAttribute('data-value');
    if (colorValue && slider.pgGoToColor) {
      slider.pgGoToColor(colorValue);
    }
  }, true);

  function boot() {
    initAll(document);
    var grid = document.body;
    if (grid && 'MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          initAll(document);
        }, 200);
      });
      mo.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ---------------------------------------------------------------------------
   Bundle ("סט תכשיטים") lock on the CART page. Runs globally but no-ops unless the
   cart items table is present. For every line whose properties carry a shared
   _bundle_id it: hides the raw _bundle_* property text, adds a "רכישה כסט" badge,
   locks the quantity, replaces the price/total cells with PLAIN values (regular
   unit price in the price column, plain final amount in the total column — no
   strikethrough/sale markup and no per-row discount subtext; the aggregate saved
   amount is already shown once in the cart's own order summary), and removes the
   per-row remove control entirely in favor of ONE "הסר את הסט" button (styled as a
   compact bordered pill, right-aligned, minimal top padding and no bottom padding)
   placed in its own full-width row right after the last line of each bundle
   group. Still can't remove a single item from a bundle, only the whole set.

   Desktop, ALL rows (not just bundle ones): the whole "הסרה" column (header +
   every cell) is hidden via CSS (see pg-slider.css, min-width:1001px block) since
   it left an empty header with nothing under it once bundle rows had their cell
   cleared. For a NON-bundle row specifically, the theme's own working remove link
   (<a class="cart__remove">, still the exact same element — just relocated, not
   rebuilt, so its href/data-index/click-handler wiring keeps working) is moved
   into the product image cell and restyled as a small round X badge in the
   image's top corner, per feedback. Bundle rows don't get this icon — removing a
   single bundled item isn't allowed, they only get the consolidated button below.

   Mobile, NON-bundle rows (per a reference screenshot, mirrored for RTL — image
   stays on the right where it already was, then refined again per a real-device
   screenshot from the user): the same real remove link is moved next to the
   product title itself — both wrapped together in a small flex row
   (.pg-mobile-title-row: title flex:1 on the right, the "×" fixed-width on the
   left) so the icon always sits at the title's own outer edge instead of
   floating separately at the top of the whole card. The qty stepper + line price
   (still the theme's own strikethrough-original/sale-price markup) are combined
   into one flex row placed below the variant text, price flush left / qty flush
   right. Bundle rows are untouched here — they keep the separate mini-grid
   design built earlier (כמות/מחיר/הנחה/לתשלום).

   Mobile: bundle rows PRICE DISPLAY — rebuilt per a reference screenshot showing a
   compact price block (final price plain/bold, original price struck through in a
   light pink pill, a red/pink "הנחה ₪X" discount-amount pill, and a low-stock line
   "נשארו רק X במלאי") underneath), replacing the earlier 4-field כמות/מחיר/הנחה/לתשלום
   mini-grid entirely (see buildBundlePriceBlock / getInventoryData below — the
   old makeCell()-based grid is gone). The whole block is direction:ltr with
   display:flex so its children start from ITS OWN left edge regardless of the
   page's overall RTL flow — this is what pins the prices to the left side per
   feedback ("חשוב שהמחירים יהיו בצד שמאל"), matching how the non-bundle rows
   above already show their price flush left in .pg-mobile-qty-price-row. Stock
   count comes from a hidden JSON data island rendered by sections/cart-template.liquid
   (id="pg-cart-inventory-data", variant_id -> {qty, tracked}) — NOT a client-side
   fetch: testing confirmed the public /products/{handle}.js AJAX endpoint always
   omits inventory_quantity even though inventory_management comes through, so the
   real count can only be read from Liquid's cart.items[].variant object at
   page-render time. The low-stock line is only shown when the variant's inventory
   is actually tracked (tracked === true, i.e. inventory_management == 'shopify')
   and the quantity is between 1–10, to avoid ever printing a meaningless large
   number or showing it for untracked variants. The badge ("רכישה כסט") keeps its
   own separate filled tan/brown pill background (unrelated to this price block,
   styled in injectStyles above the same as before).

   The "רכישה כסט" badge keeps its original filled tan/brown pill background
   (removed briefly, then restored per feedback — the fill was liked, only the
   whole ROW's background wash was not). The gap between the product image and the
   text column is handled by a real CSS flex `gap` on the row (see pg-slider.css,
   the ".pg-bundle-row" flex block) rather than a padding-right value on
   .cart__meta — padding-right is zeroed out here since (same root cause as the
   non-bundle rows above) .cart__meta renders as an anonymous table-cell, so a
   padding value on it doesn't reliably translate into a gap next to a floated
   sibling; the row is forced into display:flex instead, where `gap` is exact and
   predictable. width was reclaimed from the remove-wrap column (48px cap) so the
   meta cell could in turn afford more breathing room. The image-icon change above
   is desktop-only (gated on !isMobile) so none of this mobile tuning is affected.
   The whole-row background wash (tr.pg-bundle-row{background:#faf7f5}) has been
   removed per feedback — only the badge should carry a background color, not the
   entire card.
   Root cause of an earlier "everything is spread out" bug on mobile (found via a
   sandbox that actually re-executes this script inside a narrow same-origin
   iframe with the real cart markup + real ancestor classes + real stylesheets,
   instead of just cloning already-decorated desktop DOM): the cart table uses
   table-layout:auto with SIX columns; once the qty-stepper and remove-wrap
   columns were free to grow toward their own preferred width, the meta column
   got starved down to ~60-70px, too little for the grid's flex cells. Fixed by
   hiding the qty-stepper/price columns and capping the remove-wrap column's
   width for bundle rows on mobile, reclaiming room for the meta column.
   Everything layout-critical here is still done with inline styles set directly
   via JS so nothing depends on CSS cascade/specificity/caching.

   Quantity badge (.pg-cart-qty-badge, added for the checkout-style redesign
   pass): a small dark circle showing the line's quantity, pinned to the
   product image's own top-right corner via CSS (see pg-slider.css, the
   "checkout-style redesign" block) — mirrors the small quantity badge on the
   thumbnails in Shopify's native checkout order-summary sidebar, which the
   user shared as the visual reference for this pass. Built once per row here
   (guarded by the element's own presence, not a data-attribute, so it keeps
   getting its text refreshed on every decorate() pass -- including after an
   AJAX quantity update re-renders the row) and additionally kept in sync
   instantly while the user is still interacting with the stepper via a
   delegated 'input' listener below (decorate() only reruns after the AJAX
   round-trip finishes, which would otherwise make the badge lag a beat behind
   the number the customer just typed/clicked). This is purely an at-a-glance
   echo of the reference design -- it does NOT replace the existing editable
   +/- stepper on non-bundle rows (removing the only way to change quantity
   from the cart page would be a regression); on bundle rows, where the
   stepper is already hidden on mobile (locked quantity), the badge becomes
   the sole quantity indicator, same as in the reference.

   Number-formatting fix (per feedback with a screenshot): a raw, differently
   formatted price (the shop's own default money format, e.g. a period
   thousands separator and the word "שח" instead of "₪") was briefly visible
   on bundle rows before this script finished running -- .cart__price-wrapper
   and .cart__total-row hold the theme's own server-rendered <s>/sale markup
   from cart-template.liquid, and this script only overwrites/hides them
   AFTER an async fetch('/cart.js') resolves, so there was a real (if brief)
   window on every page load where that raw, wrongly-formatted number was
   on screen -- exactly what the feedback screenshot caught. .cart__price-wrapper,
   .cart__total-row and .cart__update-wrapper are now hidden immediately via
   CSS for bundle rows (see pg-slider.css, the ".pg-bundle-row" rules) instead
   of waiting on this script, so the raw price never paints at all; this
   script's own display:none writes below are harmless no-ops now (kept so
   nothing breaks if the CSS ever fails to load). All prices this script DOES
   render itself (buildBundlePriceBlock below) already followed the requested
   "number then currency" order (money() + ' ₪', never the reverse) and never
   needed this fix -- only the leaked-through raw theme markup did. Also per
   the same feedback: the compare price is now a plain gray strikethrough
   with no pill/background (was a pink pill), and the discount badge uses a
   cream background (#F2EFE3) instead of the earlier red/pink, both in
   injectStyles() below. */
(function () {
  function onCart() { return document.querySelector('.cart-page__items-table'); }
  function money(cents) { return (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
  // Formats an amount as "number ₪" (positive) or "number- ₪" (negative) -- ₪
  // always LAST, never a leading minus before the digits.
  //
  // UPDATED 2026-07-23 (per feedback, with a real-device screenshot, that the
  // earlier fix -- forcing CSS `direction:ltr` on the price element -- still
  // showed the number/₪ in the wrong order): forcing direction:ltr turned out
  // to be the wrong mechanism. It happened to render correctly in prior
  // testing (a desktop Chrome browser via an iframe preview), but Unicode
  // bidi resolution for a bare "digits + space + ₪" run with no explicit
  // direction is NOT guaranteed to resolve identically across every browser/
  // OS -- and evidently didn't on the user's actual phone.
  //
  // To find the objectively correct, browser-proof technique, we inspected
  // Shopify's OWN native checkout page for this exact store (unmodified by
  // us, guaranteed correctly localized for he-IL) and read its real rendered
  // price element directly: its computed `direction` is **rtl** (not ltr),
  // and its text content is not just "399.00 ₪" -- it's literally
  // RLM + "399.00" + RLM + " " + "₪" (RLM = U+200F, the invisible
  // "Right-to-Left Mark" character). Shopify anchors the number with RLM
  // marks rather than flipping the whole run to LTR. That is the proven,
  // cross-browser-safe technique, so we replicate it here: keep the
  // container `direction:rtl` (see .product-price__price / .pg-cart-summary-value /
  // .pg-cart-checkout-btn__amount in pg-slider.css, changed back from ltr to
  // rtl) and have fmt() itself embed the same RLM anchors around the digits,
  // so the correct order is guaranteed by explicit Unicode control
  // characters instead of depending on a browser's neutral-run bidi
  // resolution (which is exactly what was inconsistent before).
  function fmt(cents) {
    var neg = cents < 0;
    var n = money(Math.abs(cents));
    var RLM = '‏'; // U+200F RIGHT-TO-LEFT MARK, invisible -- see comment above
    return neg ? (RLM + n + '-' + RLM + ' ₪') : (RLM + n + RLM + ' ₪');
  }
  function injectStyles() {
    if (document.getElementById('pg-bundle-cart-style')) return;
    var s = document.createElement('style'); s.id = 'pg-bundle-cart-style';
    // .pg-bundle-price-block: switched from direction:ltr to direction:rtl +
    // flex-direction:row-reverse on 2026-07-23 (see the big comment above fmt()
    // in this file for why direction:ltr was wrong). row-reverse is needed here
    // specifically because switching a flex CONTAINER to direction:rtl also
    // flips which end of the row its DOM-order children start from (first DOM
    // child would jump from the left edge to the right edge) -- row-reverse
    // cancels that out so the visual left-to-right arrangement (final price,
    // then compare price, then discount badge) stays exactly the same as
    // before; only the TEXT direction inside each child span changes (which is
    // the actual thing that needed fixing).
    // .pg-bundle-final-price bumped 16px -> 18px per feedback (2026-07-23,
    // "את המחירים אפשר להגדיל עוד קצת") -- same request handled for the
    // non-bundle row prices in pg-slider.css.
    // תיקון נוסף 27.7.2026 (סבב 3): נוספו justify-content:flex-start ו-width:100%
    // מפורשים ל-.pg-bundle-price-block -- בעבר הסתמכנו על ברירת המחדל (normal,
    // ששקולה ל-flex-start) ועל כך שקונטיינר flex ברמת בלוק ממלא 100% מהרוחב
    // הפנוי מעצמו. נמצא בבדיקה חיה שזה עובד נכון בכרום, אבל כיוון שהתופעה
    // המדווחת (המוצר האחרון בבנדל, עם ילד יחיד בלבד -- בלי מחיר-השוואה/הנחה --
    // לא מיושר כמו האמצעי בעל 3 ילדים) חשודה כתלוית-דפדפן באזור ידוע כלא-עקבי ב-
    // (row-reverse + rtl + flex-wrap עם מספר ילדים שונה), הוספת הערכים באופן
    // מפורש מסירה את התלות בפירוש ברירת-המחדל של כל מנוע ומייצרת אותה
    // תוצאה חד-משמעית בכל דפדפן, ללא קשר למספר הילדים בפועל בכל שורה.
    s.textContent = '.pg-bundle-badge{display:inline-block;background:#efe7e1;color:#8a6f5e;font-size:12px;font-weight:600;padding:2px 8px;border-radius:999px;margin-top:4px}.pg-bundle-locked .qty-box__ctrl{display:none!important}.pg-bundle-locked .qty-box__input{border:none!important;background:transparent!important;-moz-appearance:textfield;appearance:none;pointer-events:none}.pg-bundle-row .cart-item__discount{display:none!important}.pg-bundle-price-block{direction:rtl;flex-direction:row-reverse;display:flex;align-items:center;justify-content:flex-start;flex-wrap:wrap;gap:6px;width:100%;margin-top:8px;padding-top:8px;border-top:1px solid rgba(87,75,68,.12);}.pg-bundle-final-price{font-size:18px;font-weight:600;color:#574b44;}.pg-bundle-compare-price{font-size:13px;font-weight:400;color:#a79c92;text-decoration:line-through;background:none;padding:0;border-radius:0;}.pg-bundle-discount-badge{font-size:12px;font-weight:600;color:#8a6f5e;background:#F2EFE3;padding:2px 7px;border-radius:5px;white-space:nowrap;}.pg-bundle-stock-text{width:100%;direction:rtl;text-align:left;font-size:12px;color:#a79c92;margin-top:4px;}';
    document.head.appendChild(s);
  }
  function buildBundlePriceBlock(finalLine, origLine, lineDisc) {
    var block = document.createElement('div');
    block.className = 'pg-bundle-price-block';
    var finalEl = document.createElement('span');
    finalEl.className = 'pg-bundle-final-price';
    finalEl.textContent = fmt(finalLine);
    block.appendChild(finalEl);
    if (lineDisc > 0) {
      var compareEl = document.createElement('span');
      compareEl.className = 'pg-bundle-compare-price';
      compareEl.textContent = fmt(origLine);
      block.appendChild(compareEl);
      var discEl = document.createElement('span');
      discEl.className = 'pg-bundle-discount-badge';
      // Back to a plain textContent concatenation (2026-07-23): this briefly
      // needed to be split into a nested <span> with its own forced direction
      // (see the removed .pg-price-num rule, previously in pg-slider.css) to
      // work around the OLD forced-ltr price fix. Now that fmt() embeds its
      // own RLM anchor marks (see the big comment above fmt() in this file)
      // and .pg-bundle-price-block is direction:rtl again, a plain Hebrew
      // label + fmt() result in ONE text node is self-correcting and needs no
      // extra markup.
      discEl.textContent = 'הנחה ' + fmt(lineDisc);
      block.appendChild(discEl);
    }
    var stockEl = document.createElement('div');
    stockEl.className = 'pg-bundle-stock-text';
    stockEl.style.display = 'none';
    block.appendChild(stockEl);
    return { block: block, stockEl: stockEl };
  }
  function ensureQtyBadge(row, quantity) {
    var imgWrap = row.querySelector('.cart__image-wrapper');
    if (!imgWrap) return;
    var badge = imgWrap.querySelector('.pg-cart-qty-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'pg-cart-qty-badge';
      imgWrap.appendChild(badge);
    }
    badge.textContent = quantity;
  }
  var _inventoryDataCache = null;
  function getInventoryData() {
    // Reads the hidden JSON data island rendered server-side by sections/cart-template.liquid
    // (variant_id -> {qty, tracked}). Real inventory counts are NOT exposed by the public
    // /products/{handle}.js AJAX endpoint (confirmed by direct testing: inventory_management
    // comes through but inventory_quantity is always missing), so this can only be sourced
    // from Liquid's cart.items[].variant object at page-render time.
    if (_inventoryDataCache) return _inventoryDataCache;
    var el = document.getElementById('pg-cart-inventory-data');
    if (!el) { _inventoryDataCache = {}; return _inventoryDataCache; }
    try { _inventoryDataCache = JSON.parse(el.textContent) || {}; } catch (e) { _inventoryDataCache = {}; }
    return _inventoryDataCache;
  }
  function decorate() {
    if (!onCart()) return;
    injectStyles();
    // "isMobile" -- despite the name, now ALWAYS true (2026-07-24, per feedback:
    // "צריך לשפר את זה שזה יראה כמו בתצוגה של המובייל" -- the desktop cart should
    // look like this mobile card design too). Used to be
    // `window.matchMedia('(max-width: 1000px)').matches`, which gated the DOM
    // restructuring below (title+remove-X row, combined qty+price row, compact
    // bundle price block) to narrow screens only; desktop instead got a
    // different treatment further down (relocating the remove link onto the
    // product image, see the `!isMobile && !bid` branch right below). Hardcoding
    // this to true makes every cart row -- any width, bundle or not -- go through
    // the exact same "mobile" DOM restructuring, matched by the corresponding CSS
    // in pg-slider.css (its old "@media max-width:1000px" wrappers around the
    // card-layout rules were removed the same way, for the same reason). The
    // variable name is kept as-is (rather than renamed everywhere) to keep this
    // diff small and low-risk; treat it as "use card layout" rather than a real
    // viewport check from here on.
    var isMobile = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      // Footer summary (subtotal / "you saved" / checkout button amount): same
      // currency-ordering bug as the per-line prices below -- these three are
      // rendered server-side via {% render 'price' %} in cart-template.liquid,
      // which goes through the shop's own money_format and doesn't put the
      // currency where it's supposed to go (per feedback with a screenshot).
      // Rewritten here from cart.js's own numeric totals via fmt() instead.
      var summaryValues = document.querySelectorAll('.pg-cart-summary-row .pg-cart-summary-value');
      Array.prototype.forEach.call(summaryValues, function (el) {
        var isDiscountRow = !!el.closest('.pg-cart-summary-row--discount');
        el.textContent = isDiscountRow ? fmt(-Math.abs(cart.total_discount)) : fmt(cart.total_price);
      });
      var checkoutAmountEl = document.querySelector('.pg-cart-checkout-btn__amount');
      if (checkoutAmountEl) { checkoutAmountEl.textContent = fmt(cart.total_price); }

      var rows = document.querySelectorAll('.cart-page__items-table tbody tr.cart__row');
      var lastRowByBundle = {};
      cart.items.forEach(function (it, i) {
        var row = rows[i]; if (!row) return;
        var props = it.properties || {};
        var bid = props._bundle_id;

        ensureQtyBadge(row, it.quantity);

        if (!isMobile && !bid && !row.getAttribute('data-pg-remove-icon-done')) {
          row.setAttribute('data-pg-remove-icon-done', '1');
          var imgWrap = row.querySelector('.cart__image-wrapper');
          var remWrap0 = row.querySelector('.cart__remove-wrap');
          var removeLink = remWrap0 ? remWrap0.querySelector('.cart__remove') : null;
          if (imgWrap && removeLink) {
            removeLink.classList.add('pg-remove-icon-btn');
            imgWrap.appendChild(removeLink);
          }
        }

        if (isMobile && !bid && !row.getAttribute('data-pg-mobile-restyle-done')) {
          row.setAttribute('data-pg-mobile-restyle-done', '1');
          var metaM = row.querySelector('.cart__meta');
          var remWrapM2 = row.querySelector('.cart__remove-wrap');
          var removeLinkM = remWrapM2 ? remWrapM2.querySelector('.cart__remove') : null;
          var titleM = metaM ? metaM.querySelector('.list-view-item__title') : null;
          if (metaM && removeLinkM && titleM) {
            removeLinkM.classList.add('pg-mobile-remove-x');
            var titleRowM = document.createElement('div');
            titleRowM.className = 'pg-mobile-title-row';
            titleM.parentNode.insertBefore(titleRowM, titleM);
            titleRowM.appendChild(titleM);
            titleRowM.appendChild(removeLinkM);
          }
          var qtyBoxM = row.querySelector('.qty-box--cart');
          var totalRowM = row.querySelector('.cart__total-row');
          if (metaM && qtyBoxM && totalRowM) {
            var subRow = document.createElement('div');
            subRow.className = 'pg-mobile-qty-price-row';
            subRow.appendChild(qtyBoxM);
            while (totalRowM.firstChild) { subRow.appendChild(totalRowM.firstChild); }
            metaM.appendChild(subRow);
            // Re-render this line's price with fmt() instead of leaving the
            // theme's own server-rendered <s>/sale markup in place -- that
            // markup comes from the {% render 'price' %} snippet in
            // cart-template.liquid, which uses the shop's own money_format
            // setting, and per feedback with a screenshot ("3,200 ₪" with
            // the currency landing before the number) that format doesn't
            // put the currency where it's supposed to go. Same classes kept
            // (s.product-price__price / .product-price__sale) so all the
            // existing styling above still applies untouched.
            var priceElM = subRow.querySelector('.product-price');
            if (priceElM) {
              var origLineM = (typeof it.original_line_price === 'number') ? it.original_line_price : it.line_price;
              var finalLineM = (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
              if (origLineM !== finalLineM) {
                priceElM.innerHTML = '<s class="product-price__price">' + fmt(origLineM) + '</s><span class="product-price__price product-price__sale">' + fmt(finalLineM) + '</span>';
              } else {
                priceElM.innerHTML = '<span class="product-price__price">' + fmt(finalLineM) + '</span>';
              }
            }
          }
        }

        if (!bid) return;
        if (row.getAttribute('data-pg-bundle-done')) return;
        row.setAttribute('data-pg-bundle-done', '1');
        row.classList.add('pg-bundle-row');
        row.setAttribute('data-bundle-id', bid);
        Array.prototype.forEach.call(row.querySelectorAll('.cart__meta-text'), function (m) { if (/_bundle_/.test(m.textContent)) m.style.display = 'none'; });
        var meta = row.querySelector('.cart__meta'); var title = row.querySelector('.list-view-item__title');
        if (meta && title && !meta.querySelector('.pg-bundle-badge')) { var b = document.createElement('div'); b.className = 'pg-bundle-badge'; b.textContent = 'רכישה כסט'; title.insertAdjacentElement('afterend', b); }
        var qty = row.querySelector('.qty-box--cart'); if (qty) { qty.classList.add('pg-bundle-locked'); var inp = qty.querySelector('.qty-box__input'); if (inp) { inp.setAttribute('readonly', 'readonly'); inp.classList.remove('qty-box__input--sync'); } }
        var alloc = it.line_level_discount_allocations || [];
        var lineDisc = 0; alloc.forEach(function (d) { lineDisc += (typeof d.amount === 'number' ? d.amount : (parseInt(d.amount, 10) || 0)); });
        Array.prototype.forEach.call(row.querySelectorAll('.cart-item__discount'), function (el) { el.remove(); });
        var finalLine = (typeof it.final_line_price === 'number') ? it.final_line_price : (it.line_price - lineDisc);
        var priceWrapperEl = row.querySelector('.cart__price-wrapper');
        if (priceWrapperEl) { priceWrapperEl.innerHTML = '<span class="product-price__price"><span class="money">' + fmt(it.price) + '</span></span>'; }
        var totalRowEl = row.querySelector('.cart__total-row');
        if (totalRowEl) { totalRowEl.innerHTML = '<div class="product-price"><span class="product-price__price"><span class="money">' + fmt(finalLine) + '</span></span></div>'; }
        if (isMobile && meta && !meta.querySelector('.pg-bundle-price-block')) {
          if (totalRowEl) totalRowEl.style.display = 'none';
          var qtyBoxCart = row.querySelector('.qty-box--cart'); if (qtyBoxCart) qtyBoxCart.style.display = 'none';
          var updateWrapper = row.querySelector('.cart__update-wrapper'); if (updateWrapper) updateWrapper.style.setProperty('display', 'none', 'important');
          if (priceWrapperEl) priceWrapperEl.style.setProperty('display', 'none', 'important');
          var removeWrapM = row.querySelector('.cart__remove-wrap');
          if (removeWrapM) { removeWrapM.style.setProperty('width', '48px', 'important'); removeWrapM.style.setProperty('max-width', '48px', 'important'); }
          meta.style.setProperty('padding-left', '0px', 'important');
          meta.style.setProperty('padding-right', '16px', 'important');
          meta.style.setProperty('width', 'auto', 'important');
          var origLine = (typeof it.original_line_price === 'number') ? it.original_line_price : it.line_price;
          var built = buildBundlePriceBlock(finalLine, origLine, lineDisc);
          meta.appendChild(built.block);
          var invMap = getInventoryData();
          var invInfo = invMap[String(it.variant_id)];
          if (invInfo && invInfo.tracked && typeof invInfo.qty === 'number' && invInfo.qty > 0 && invInfo.qty <= 10) {
            built.stockEl.textContent = 'נשארו רק ' + invInfo.qty + ' במלאי';
            built.stockEl.style.display = 'block';
          }
        }
        var rem = row.querySelector('.cart__remove-wrap'); if (rem) { rem.innerHTML = ''; }
        lastRowByBundle[bid] = row;
      });
      Object.keys(lastRowByBundle).forEach(function (bid2) {
        var lastRow = lastRowByBundle[bid2];
        var existing = document.querySelector('tr.pg-bundle-remove-row[data-bundle-id="' + bid2 + '"]');
        if (existing) existing.remove();
        var colCount = lastRow.children.length;
        var tr = document.createElement('tr');
        tr.className = 'pg-bundle-remove-row';
        tr.setAttribute('data-bundle-id', bid2);
        var td = document.createElement('td');
        td.setAttribute('colspan', String(colCount));
        // padding-top tightened 8px -> 4px per feedback (2026-07-23, "reduce the
        // gaps"). text-align:right is reinforced with !important in pg-slider.css
        // (.pg-bundle-remove-row td) since this inline style alone wasn't winning
        // against the theme's ".text-center" ancestor class.
        td.setAttribute('style', 'text-align:right;padding:4px 0 0 0;border-top:1px solid rgba(87,75,68,.12);');
        var btn = document.createElement('a');
        btn.setAttribute('href', '#');
        btn.setAttribute('data-remove-bundle', bid2);
        btn.textContent = 'הסר את הסט';
        // Switched from a bordered pill button to a small plain underlined link
        // per feedback (2026-07-23, "להקטין אותו בלי מסגרות נוספות" -- shrink it,
        // no extra frames/borders). border/border-radius/padding removed here
        // (also reinforced in pg-slider.css in case of any specificity issues).
        btn.setAttribute('style', 'display:inline-block;font-size:11px;color:#8a6f5e;text-decoration:underline;cursor:pointer;border:none;padding:2px 0;margin:0;');
        td.appendChild(btn);
        tr.appendChild(td);
        lastRow.parentNode.insertBefore(tr, lastRow.nextSibling);
      });
    }).catch(function () { /* no-op */ });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-remove-bundle]') : null;
    if (!btn) return;
    e.preventDefault();
    var bid = btn.getAttribute('data-remove-bundle');
    if (!window.confirm('להסיר את כל סט התכשיטים מהעגלה?')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (it.properties && it.properties._bundle_id === bid) updates[it.key] = 0; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
  });
  // Keep the quantity badge in sync the instant the customer types into or clicks
  // the +/- stepper -- decorate() only re-runs after the AJAX update round-trip
  // finishes, which would otherwise leave the badge showing the pre-change number
  // for a moment. Delegated so it works for badges built after this listener runs.
  document.addEventListener('input', function (e) {
    var inp = e.target.closest ? e.target.closest('.qty-box__input') : null;
    if (!inp) return;
    var row = inp.closest ? inp.closest('tr.cart__row') : null;
    if (!row) return;
    var badge = row.querySelector('.pg-cart-qty-badge');
    if (badge) badge.textContent = inp.value || '0';
  });
  function boot() {
    if (!onCart()) return;
    decorate();
    var host = document.querySelector('.cart-page');
    if (host && 'MutationObserver' in window) {
      var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 300); });
      mo.observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---------------------------------------------------------------------------
   Bundle ("סט תכשיטים") styling in the SIDE CART DRAWER (snippets/header-cart-content.liquid,
   rendered inside #bt-sidebar-cart on every page except /cart). This is a completely
   separate template from the full cart page (.hc__item instead of .cart__row, .qty-box
   instead of .qty-box--cart, etc.) so none of the work above ever reached it -- it was
   still showing the raw "_bundle_id: ..." property lines with no badge.
   Per feedback: editing (changing quantity / removing a line) should only be possible
   from the full cart page, not from this quick-access drawer -- the theme's own AJAX
   remove/qty handlers operate on a single line and would silently break a bundle's
   "can't remove one item, only the whole set" rule. So bundle rows here get the same
   badge + hidden-properties treatment, but the quantity stepper is locked read-only and
   the remove button is replaced with a small "עריכה בעגלה" link to /cart instead.
   Deliberately additive-only (no display/layout-mode changes) -- the drawer's own table
   layout is left untouched. */
(function () {
  function drawerHost() { return document.getElementById('bt-sidebar-cart'); }
  function injectStyles() {
    if (document.getElementById('pg-bundle-drawer-style')) return;
    var s = document.createElement('style'); s.id = 'pg-bundle-drawer-style';
    s.textContent = '#bt-sidebar-cart .pg-bundle-badge{display:inline-block;background:#efe7e1;color:#8a6f5e;font-size:11px;font-weight:600;padding:2px 8px;border-radius:999px;margin:4px 0}#bt-sidebar-cart .pg-bundle-locked .qty-box__ctrl{display:none!important}#bt-sidebar-cart .pg-bundle-locked .qty-box__input{border:none!important;background:transparent!important;pointer-events:none}#bt-sidebar-cart .pg-bundle-edit-note{color:#a79c92;font-size:11px;text-decoration:underline;white-space:nowrap}';
    document.head.appendChild(s);
  }
  function decorate() {
    var host = drawerHost(); if (!host) return;
    injectStyles();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var rows = host.querySelectorAll('.hc__items tbody tr.hc__item');
      cart.items.forEach(function (it, i) {
        var row = rows[i]; if (!row) return;
        var props = it.properties || {};
        var bid = props._bundle_id; if (!bid) return;
        if (row.getAttribute('data-pg-bundle-done')) return;
        row.setAttribute('data-pg-bundle-done', '1');
        Array.prototype.forEach.call(row.querySelectorAll('.cart__meta-text'), function (m) { if (/_bundle_/.test(m.textContent)) m.style.display = 'none'; });
        var nameCell = row.querySelector('.hc__item__name');
        var titleLink = nameCell ? nameCell.querySelector('a') : null;
        if (titleLink && nameCell && !nameCell.querySelector('.pg-bundle-badge')) {
          var b = document.createElement('div'); b.className = 'pg-bundle-badge'; b.textContent = 'רכישה כסט';
          titleLink.insertAdjacentElement('afterend', b);
        }
        var qty = row.querySelector('.qty-box');
        if (qty) { qty.classList.add('pg-bundle-locked'); var inp = qty.querySelector('.qty-box__input'); if (inp) inp.setAttribute('readonly', 'readonly'); }
        var rem = row.querySelector('.hc__item__remove-wrap');
        if (rem) { rem.innerHTML = '<a href="/cart" class="pg-bundle-edit-note">עריכה בעגלה</a>'; }
      });
    }).catch(function () { /* no-op */ });
  }
  function boot() {
    var host = drawerHost();
    if (!host) return;
    decorate();
    if ('MutationObserver' in window) {
      var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 250); });
      mo.observe(host, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('[data-target="#bt-sidebar-cart"]') : null;
      if (trigger) setTimeout(decorate, 200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---------------------------------------------------------------------------
   Hide any per-line cart discount label whose displayed amount is exactly 0
   (e.g. "סט תכשיטים (-0 ₪)"). This is native Shopify markup rendered server-side
   by cart-template.liquid via {% for discount in item.line_level_discount_allocations %}
   -- it shows the discount's NAME for every line associated with an automatic
   discount, even when that specific line's own allocation amount is 0 (e.g. an
   automatic "buy the set" discount that matches the line for eligibility purposes
   but computes no actual reduction for it). True bundle rows (with a _bundle_id
   line property) already have their whole .cart-item__discount div removed
   unconditionally above; this covers the remaining case of an ordinary,
   non-bundle-tagged line that still shows a $0 discount caption. Purely a text
   check on the rendered money span -- no cart.js fetch needed, so it can run
   synchronously and stay independent of the bundle logic above. */
(function () {
  function hideZeroDiscounts() {
    if (!document.querySelector('.cart-page__items-table')) return;
    Array.prototype.forEach.call(document.querySelectorAll('.cart-item__discount'), function (el) {
      if (el.style.display === 'none') return;
      var moneyEl = el.querySelector('.money');
      var text = moneyEl ? moneyEl.textContent : el.textContent;
      var digits = (text || '').replace(/[^\d.]/g, '');
      var val = parseFloat(digits);
      if (!isNaN(val) && val === 0) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function boot() {
    hideZeroDiscounts();
    var host = document.querySelector('.cart-page');
    if (host && 'MutationObserver' in window) {
      var t;
      var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(hideZeroDiscounts, 200); });
      mo.observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
